import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  inject,
} from '@angular/core';
import { CourseCategoryDialogComponent } from '../../Dialogs/course-category-dialog/course-category-dialog.component';
import { Course, CourseCategory, CourseEvent } from 'TrainingTrackingDataTypes';
import {
  AutoDropdownComponent,
  ListViewComponent,
  listRow,
  getExtraBurgerMenuOptions,
  MenuOption,
} from '@standard-angular-utilities/shared-components';
import { User, LogDTO, LogType } from 'BaseDataTypes';
import { UserService } from 'BaseServices/user-service';

import { FormsModule } from '@angular/forms';
import { CourseCategoryService } from 'TrainingTrackingServices/course-categories-service';
import { CourseEventLogService } from 'TrainingTrackingServices/course-event-log-service';
import { MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { LogService } from 'BaseServices/log-service';
import { SharedFunctionsService } from 'BaseServices/sharedFunctions.service';
import { LogHelperService } from 'BaseServices/log-helper.service';

@Component({
  selector: 'app-course-category-view',
  templateUrl: './course-category-view.component.html',
  styleUrl: './course-category-view.component.css',
  imports: [ListViewComponent, FormsModule, MatButtonModule],
})
export class CourseCategoryViewComponent implements OnInit, AfterViewInit {
  @ViewChild('listView') listView!: ListViewComponent<CourseCategory>;
  @ViewChild('logListView') logListView!: ListViewComponent<LogDTO>;
  readonly dialog = inject(MatDialog);

  onChangeFunction: () => void = () => {};

  courses: Course[] = [];
  courseCateg: CourseCategory[] = [];
  courseCategoryHeaderList: string[] = ['Kategori'];
  logHeaderList: string[];
  headerList: string[] = this.courseCategoryHeaderList;
  isHistory: boolean = false;
  users: User[] = [];
  currentUser = this.userService.currentUser;
  extraBurgerMenuOptions: MenuOption[] = [];

  selectedCategory: number = 0;
  constructor(
    private courseCategoryService: CourseCategoryService,
    private courseEventLogService: CourseEventLogService,
    private userService: UserService,
    private sharedFunctionsService: SharedFunctionsService,
    private logService: LogService,
    private logHelper: LogHelperService
  ) {
    this.logHeaderList = this.logService.getLogHeaders('Kursuskategori');
  }

  /**
   * Function which creates a default course category, and opens it in the dialog
   */
  createNewCourseCategory() {
    let defaultCourseCategory: CourseCategory = { id: 0, name: '' };
    this.openCourseCategoryDialog(defaultCourseCategory);
  }

  /**
   * Function which opens CourseCategoryDialogComponent with the supplied course
   * @param courseCategory
   */
  openCourseCategoryDialog(courseCategory: CourseCategory) {
    let dialogref = this.dialog.open(CourseCategoryDialogComponent, {
      data: { data: [{ ...courseCategory }] },
    });
    dialogref.afterClosed().subscribe((result) => {
      if (result == true) {
        this.updateListWithCourseCategoryData();
      }
    });
  }

  ngOnInit(): void {
    const isAdmin =
      this.userService.getSelectedRole ===
      this.userService.getUserRoleTypes.Admin;
    const customLabel = 'Skift til kursuskategori';

    this.extraBurgerMenuOptions = getExtraBurgerMenuOptions(
      isAdmin,
      this.isHistory,
      customLabel,
      this.switchDataInList.bind(this),
      () => this.extraBurgerMenuOptions[0][0],
      (newLabel: string) => {
        this.extraBurgerMenuOptions[0][0] = newLabel;
      }
    );
  }

  ngAfterViewInit(): void {
    this.updateListWithCourseCategoryData();
  }

  /**
   * Gets users from backend, users are used by the course event log.
   */
  getAllUsers() {
    this.userService.getUsers().subscribe((result) => {
      this.users = result;
    });
  }
  /**
   * Gets CourseCategories from backend.
   */
  getAllCourseCategories() {
    this.courseCategoryService.getCourseCategories().subscribe((result) => {
      this.courseCateg = result;
    });
  }

  /**
   * Helper function for updateListWithEventlogData
   * @param id
   * @returns Name by user id or "Bruger ikke fudet"
   */
  getUserNameFromUserId(id: number): string {
    return (
      this.users.find((user) => user.id === id)?.name || 'Bruger ikke fundet'
    );
  }

  /**
   * Helper function for updateListWithEventlogData
   * @param id
   * @returns Name by courseCategory id or "Kategori ikke fudet"
   */
  getCourseCategoryNameFromCourseCategoryId(id: number): string {
    return (
      this.courseCateg.find((courseCategory) => courseCategory.id === id)
        ?.name || id.toString()
    );
  }

  /**
   * Function which switches the list between courses categories and the course category event log.
   */
  switchDataInList() {
    if (this.isHistory) {
      this.updateListWithCourseCategoryData();
      this.isHistory = false;
    } else {
      this.updateListWithLogData();
      this.isHistory = true;
    }
  }

  /**
   * Function to update list with eventlog data
   */
  updateListWithLogData() {
    this.logHelper.updateLogList(
      LogType.CourseCategory,
      this.getCourseCategoryNameFromCourseCategoryId.bind(this),
      (data) => (this.logListView.listData().listData = data),
      () => this.logListView.update()
    );
  }

  /**
   * Function to update list with course category data
   */
  updateListWithCourseCategoryData() {
    this.courseCategoryService.getCourseCategories().subscribe((result) => {
      let tempList: listRow<CourseCategory>[] = [];
      result.forEach((courseCategory) => {
        tempList.push({
          object: courseCategory,
          id: courseCategory.id,
          data: [courseCategory.name],
        });
      });
      this.courseCateg = result;
      this.headerList = this.courseCategoryHeaderList;
      this.listView.listData().listData = tempList;
      this.listView.update();
    });
  }
}
